module.exports = __webpack_public_path__ + "static/media/react.4a5c3761.svg";